<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-brand">
      <div class="card-icon">
        <md-icon>group</md-icon>
      </div>
      <h4 class="title">Grupa</h4>
    </md-card-header>
    <md-card-content>
      <div
        v-for="(param, index) in groupParams"
        :key="index"
        class="md-layout-item md-size-100"
      >
        <md-field v-if="param.type === 'input'">
          <label>
            {{ param.label }}
          </label>
          <md-input v-model="param.selected" type="text"> </md-input>
        </md-field>

        <md-field
          v-if="param.type === 'slider'"
          class="md-layout-item md-size-100"
        >
          <md-radio
            v-for="(option, index) in param.options"
            v-model="param.selected"
            :key="index"
            :value="index"
          >
            {{ option }}
          </md-radio>
        </md-field>
      </div>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-success" @click="saveGroup"> Sačuvaj </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';
export default {
  props: {
    id: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      groupParams: [],
      levels: {},
    };
  },
  methods: {
    getGroupParams() {
      api
        .get(services.users.getGroup, {
          loadGroup: true,
          groupId: this.id ? this.id : null,
        })
        .then((data) => {
          this.groupParams = data;
        })

        .catch((error) => {
          this.alertError(error);
        });
    },
    saveGroup() {
      const requestParams = {
        createGroup: true,
      };
      if (this.id !== 0) requestParams.id = this.id;
      this.groupParams.forEach((el) => {
        if (el.selected !== 0) requestParams[el.name] = el.selected;
      });
      api
        .post(services.users.saveGroup, requestParams)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message:
              'Ažurirana grupa ' +
              this.groupParams.find((el) => el.name === 'name').selected,
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success',
          });
          this.$emit('saved-group', true);
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
  },
  mounted() {
    this.getGroupParams();
  },
  watch: {
    id() {
      this.getGroupParams();
    },
  },
};
</script>
